export const AddressLoading = 'addressLoading';
export const AddressSuccess = 'addressSuccess';
export const AddressFailure = 'addressFailure';